var i = function i(n, r) {
  var e = "",
    t = [];
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(n)) return t = n.substring(1).split(""), t.length === 3 && (t = [t[0], t[0], t[1], t[1], t[2], t[2]]), e = "0x".concat(t.join("")), "rgba(".concat([e >> 16 & 255, e >> 8 & 255, e & 255].join(","), ", ").concat(r, ")");
  throw new Error("Bad Hex");
};
export { i as withOpacity };